/**
 * Known energy icon components by range
 *
 * This global constant defines which energy rating letters are available for each range.
 *
 * To add support for new energy rating ranges, add the range as a key with an array
 * of valid letters as the value.
 *
 * @example
 * // To add A-K range support:
 * // AK: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K']
 */
const KNOWN_COMPONENTS = {
    AG: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
    AF: ['A', 'B', 'C', 'D', 'E', 'F', 'APlus'],
};

/**
 * Synchronously checks if an energy icon component exists for a given range and letter
 *
 * This function provides a fast, synchronous way to validate component existence
 * before attempting dynamic imports. It's used as a performance optimization to
 * avoid unnecessary import attempts for non-existent components.
 *
 * @param range - The energy rating range (e.g., 'AG', 'AF')
 * @param letter - The specific energy rating letter (e.g., 'A', 'B', 'APlus')
 * @returns true if the component exists, false otherwise
 */
export function hasEnergyIconComponent(range: string, letter: string): boolean {
    const validLetters = KNOWN_COMPONENTS[range as keyof typeof KNOWN_COMPONENTS];
    return validLetters ? validLetters.includes(letter) : false;
}
